import { fmtAmt, docLabel } from "./finConst";

const rowCls = (lvl) => (lvl === 0 ? "bg-amber-50/60 font-bold" : lvl === 1 ? "font-semibold" : "");
const padCls = (lvl) => (lvl === 0 ? "pl-3" : lvl === 1 ? "pl-6" : "pl-10 text-slate-600");

// Tek belgenin bölümünü (aktif / pasif / gelir) satır satır çizer; seviye (I. / A. / 1.) girintiyle gösterilir
function Section({ title, items, columns, testid }) {
  return (
    <div className="bg-white border border-slate-200 rounded-lg overflow-hidden" data-testid={testid}>
      <div className="px-4 py-2.5 border-b border-slate-100 bg-slate-50 text-xs font-bold uppercase tracking-wider text-slate-700">{title}</div>
      {items.length === 0 ? <div className="px-4 py-6 text-xs text-slate-400">Kalem okunamadı</div> : (
        <table className="w-full tbl">
          <thead><tr>
            <th className="px-3 py-1.5 text-left text-[10px] uppercase tracking-wider text-slate-500">Kalem</th>
            {columns.map((c) => <th key={c} className="px-3 py-1.5 text-right text-[10px] uppercase tracking-wider text-slate-500">{c}</th>)}
          </tr></thead>
          <tbody>
            {items.map((it, i) => (
              <tr key={i} className={`border-t border-slate-100 ${rowCls(it.level ?? 2)}`}>
                <td className={`py-1 pr-3 text-xs text-slate-800 ${padCls(it.level ?? 2)}`}>{it.name}</td>
                {columns.map((c, j) => <td key={c} className="numeric-cell px-3 py-1 text-xs">{fmtAmt(it.vals[j])}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

// Bilanço: Aktif ve Pasif yan yana, Gelir Tablosu altta; birden fazla belge seçiliyse belge başına blok
export default function Statements({ docs }) {
  const shown = docs.filter((d) => ["kurumlar", "gecici"].includes(d.doc_type));
  if (!shown.length) return <div className="p-8 text-center text-sm text-slate-500 border border-slate-200 rounded-lg bg-white" data-testid="fin-statements-empty">Bilanço / gelir tablosu için listeden bir beyanname seçin (satıra tıklayın).</div>;
  return (
    <div className="space-y-8" data-testid="fin-statements">
      {shown.map((d) => {
        const items = d.parsed?.items || [];
        const cols = d.parsed?.columns?.length ? d.parsed.columns : ["Tutar"];
        const by = (s) => items.filter((it) => it.section === s);
        return (
          <div key={d.id} className="space-y-4" data-testid={`fin-statement-${d.id}`}>
            <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
              <h2 className="text-base md:text-lg font-bold text-slate-900">{d.company}</h2>
              <span className="text-xs text-slate-500">{docLabel(d)}{d.vkn ? ` · VKN ${d.vkn}` : ""}</span>
              {!d.parsed?.ok && <span className="text-[11px] px-2 py-0.5 rounded bg-amber-100 text-amber-800 font-semibold">Kalemler okunamadı — dosya ekranda gösterilemiyor, indirip inceleyin</span>}
            </div>
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
              <Section title="Bilanço — Aktif (Varlıklar)" items={by("aktif")} columns={cols} testid={`fin-aktif-${d.id}`} />
              <Section title="Bilanço — Pasif (Kaynaklar)" items={by("pasif")} columns={cols} testid={`fin-pasif-${d.id}`} />
            </div>
            <Section title="Gelir Tablosu" items={by("gelir")} columns={cols} testid={`fin-gelir-${d.id}`} />
          </div>
        );
      })}
    </div>
  );
}
